<template>
<div>
        <v-card v-if="success" class="mx-auto text-center mt-5 animate__animated animate__fadeIn" max-width="400">
                <v-card-text class="text-center"> เปลี่ยนรหัสผ่านเรียบร้อยแล้วค่ะ</v-card-text>

        </v-card>
    <v-card v-else  class="mx-auto text-center mt-5 animate__animated animate__fadeIn" max-width="400" outlined :class="boxClass">
        <v-list-item three-line>
            <v-list-item-content>

                <v-list-item-title class="headline mb-1">
                    ตั้งรหัสผ่านใหม่
                </v-list-item-title>
                <div v-html="Msg" class="mb-2" :class="boxClass"></div>

                <v-form ref="form" v-model="valid" lazy-validation>

                    <v-text-field class="mt-4" type="password" v-model="data.currentPassword" :rules="currentPasswordRules" label="รหัสผ่านปัจุบัน" required outlined></v-text-field>

                    <v-text-field class="mt-4" type="password" v-model="data.newPassword" :rules="newPasswordRules" label="รหัสผ่านใหม่" required outlined></v-text-field>

                    <div class="text-center">
                        <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">
                            บันทึก
                        </v-btn>
                    </div>

                </v-form>

            </v-list-item-content>

        </v-list-item>

    </v-card>
</div>
</template>

<script>
 export default {

     components: {},

     data: () => ({
        success:null,
         valid: true,
         boxClass:null,
         data: {
             newPassword: null,
             currentPassword: null,
         },

         Msg: null,
         currentPasswordRules: [
             v => !!v || 'โปรดระบุ รหัสผ่านปัจุบันด้วยค่ะ'
         ],
         newPasswordRules: [
             v => !!v || 'โปรดระบุ รหัสผ่านใหม่ที่ต้องการด้วยค่ะ'
         ],
     }),

     computed: {

     },

     watch: {

     },
     methods: {

         validate() {
             this.$refs.form.validate()
             let $vm = this
             setTimeout(function () {
                 if ($vm.valid == true) {

                     $vm.updatePassword()

                 }
             }, 100);
         },

         updatePassword() {
            let url = "account/changePassword";
            
            this.loading = true
            let $vm = this;
            $vm.boxClass = ''
            $vm.Msg = null
            const formData = this.$formData(
                this.data
            );

            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res) 
                        if (res.data.check != 'success') {  
                            setTimeout(function () {
                                $vm.boxClass = 'animate__animated animate__shakeX';
                                $vm.Msg = '<div class="text-center errorMsg">รหัสผ่านปัจุบันไม่ถูกต้องค่ะ</div>'
                            }, 100);

                        }
                        else{
                                $vm.success= true
                        }
                         
                   
                })
                .catch(function (error) {
                    console.log(error);
                });

         },

     },
     created() {

     },
 };
</script>
